import type { RoleOverviewRole } from './components/RoleOverviewScreen/RoleOverviewScreen.types'

interface FullPageOnboardingBaseProps {
  onComplete: () => void
}

interface ChampionFullPageOnboardingProps extends FullPageOnboardingBaseProps {
  variant: 'champion'
  onOpenFullTour: () => void
}

interface RoleFullPageOnboardingProps extends FullPageOnboardingBaseProps {
  variant: 'role-overview'
  roles: RoleOverviewRole[]
  userName: string
}

export type FullPageOnboardingProps =
  | ChampionFullPageOnboardingProps
  | RoleFullPageOnboardingProps
